/* Copyright (c) 2022 Xperi. All Rights Reserved.  */

import React, { FunctionComponent } from 'react';
import PropTypes from 'prop-types';
import { useSelector } from 'react-redux';
import { DeviceModel } from '../../../core/device';
import { CursorManager } from '../../../core/navigation';
import { RootState } from '../../../store/root.reducers';
import { GridGuideFooterProps } from './GridGuideFooterProps';

import secondaryBranding from '../../../assets/images/branding-secondary.png';

import './GridGuideFooter.scss';

const GridGuideFooter: FunctionComponent<GridGuideFooterProps> = (props): JSX.Element => {
    const {
        selectedChannelType: channelsTypeText,
        highlightId,
        optionsMessage: selectText,
        settingsMessageFirstPart,
        settingsMessageMiddlePart,
        settingsMessageLastPart,
    } = props;
    const { isChannelsServiceFail } = useSelector((state: RootState) => state.gridGuide);
    const { value: mouseTrapValue } = useSelector((state: RootState) => state.inputFactory);

    const settingsKey = DeviceModel.isWebOsPlatform() ? (
        <span className="blue-tip-icon"></span>
    ) : (
        <span className="btn-oval"> {'D'}</span>
    );

    const extraKey = (
        <div className="extra-key-box">
            <div className="oval red"></div>
            <div className="oval green"></div>
            <div className="oval yellow"></div>
            <div className="oval blue"></div>
        </div>
    );

    const message = DeviceModel.isWebOsPlatform() ? (
        <>
            {settingsMessageFirstPart}
            {settingsKey}
            {settingsMessageLastPart}
        </>
    ) : (
        <>
            {settingsMessageFirstPart}
            {' /'}
            {extraKey}
            {settingsMessageMiddlePart}
            {settingsKey}
            {settingsMessageLastPart}
        </>
    );
    let showFooterTipText = selectText;
    if (DeviceModel.isWebOsPlatform() && CursorManager.isCursorAppeared()) {
        showFooterTipText = highlightId === mouseTrapValue ? selectText : '';
    }
    return (
        <div className="footer-container">
            <img
                className="footer-branding-icon"
                src={secondaryBranding}
                data-testid="guide-footer-branding-icon"
            />
            <div className="footer-return-text" data-testid="guide-footer-return-text">
                {message}
            </div>
            <div className="footer-select-and-all-channels-text">
                {!isChannelsServiceFail ? (
                    <span data-testid="guide-footer-select-text">{showFooterTipText}</span>
                ) : null}
                <span className="footer-tip-text-bullet"></span>
                {!isChannelsServiceFail ? (
                    <span data-testid="guide-footer-all-channels-text">
                        {channelsTypeText?.toLowerCase()}
                    </span>
                ) : null}
            </div>
        </div>
    );
};

GridGuideFooter.propTypes = {
    selectedChannelType: PropTypes.string,
    highlightId: PropTypes.string,
    optionsMessage: PropTypes.string,
    settingsMessageFirstPart: PropTypes.string,
    settingsMessageMiddlePart: PropTypes.string,
    settingsMessageLastPart: PropTypes.string,
};
export default GridGuideFooter;
